import React from "react";

const DeleteDataPage: React.FC = () => {
  return (
    <main style={{ padding: "24px" }}>
      <h2>User Data Deletion – KunalDoorAndMore</h2>
      <p>
        If you wish to delete your data from our app, please contact us at{" "}
        <a href="mailto:Kunaldoors@gmail.com">Kunaldoors@gmail.com</a>. Provide your registered phone number and we will delete your data within 7 business days.
      </p>
    </main>
  );
};

export default DeleteDataPage;
